import { DataModel } from "common/models/utility-models/base-model";

export class MentorLogsFilterModel extends DataModel {
    mentorGender:string='';
    search:string="";
    batch_number:string="";
    mentorName:string="";
}